import React from "react";
import {Button, ButtonGroup} from "reactstrap";
import TextLabel from "../../Controls/TextLabel.mjs";
import HintImage from "../../media/images/hint.svg";
import TimerImage from "../../media/images/timer.svg";
import InjectionIcon from "../../media/images/InjectionIcon.mjs";

const G = window.glob;
const Injection = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { injection: G.clone(props.injection) };
		this.do = this.do.bind(this);
		this.uid = G.generateUid('Injection');
	}
	componentDidMount() {
		G.register('InjectionChanged',ni => {
			if ( ! ni?.id ) return;
			if ( ni.id !== this.state.injection?.id ) return;
			const pi = G.clone( this.state.injection );
			Object.entries( ni.data ).forEach( ([key, value]) => { pi.data[key] = value; });
			this.setState({ injection: pi, newdata: ni });
		}, this.uid);
	}
	componentWillUnmount() {
		G.unregister('InjectionChanged', this.uid);
	}
	image(inj) {
		const t = inj?.type;
		let i;
		switch (t) {
			case 'injection':
				i = inj.startTimer ? <img src={TimerImage} alt={"Injection"}/> : <InjectionIcon/>;
				break;
			case 'hint':
				i = <img src={HintImage} alt={"Hint"} />;
				break;
			default: break;
		}
		return i ? <div className={"thumb"}>{i}</div> : '';
	}
	do() {
		const newdata = G.clone(this.state.injection);
		newdata.via = "mail";
		if ( ! newdata.data ) newdata.data = {};
		newdata.data.html = true;
		G.trigger(
			'OpenMailEditor',
			{
				message: newdata.data,
				title: this.props.injection.name,
				comment: this.props.injection.desc,
				icon: <InjectionIcon />,
				send: async (data) => {
					newdata.data = data;
					G.trigger('event:Admin', { command:'FullInjection', data: newdata });
					return {};
				}
			}
		)
	}
	render() {
		const i = this.state.injection;
		return(
			<div
				id={this.uid}
				className={"Injection"}
				data-id={ i.id }
			>
				{ this.image(i) }
				<div
					className={"Name"}
				>
					{ i.name }
				</div>
				<div className={"Buttons"}>
					<ButtonGroup>
						<Button
							color={"danger"}
							className={"btn-icon"}
							onClick={ () => {
								if ( ! window.confirm( G.label('ConfirmCancelInjection', i) )) return;
								G.trigger('event:Admin', { command:'CancelInjection', data: i });
							}}
						>
							<i>
								<TextLabel value={"delete"} lang={"icon"} />
							</i>
							<b>
								<TextLabel value={"Skip"} />
							</b>
						</Button>
						<Button
							color={"success"}
							className={"btn-icon"}
							onClick={ () => { this.do(); }}
						>
							<b>
								<TextLabel value={"Send"} />…
							</b>
							<i>
								<TextLabel value={"forward"} lang={"icon"} />
							</i>
						</Button>
					</ButtonGroup>
				</div>
				<div className={"Desc"}>
					{ i.desc }
				</div>
			</div>
		);
	}
}

export default Injection;
